import Seo from "components/Seo"
import type { HeadProps } from "gatsby"
import { fmobile, fresponsive, ftablet } from "library/fullyResponsive"
import { Suspense } from "react"
import Hero from "sections/01-Hero"
import SocialProof from "sections/02-SocialProof"
import YouVeePees from "sections/03-UVPs"
import Testimonials from "sections/04-Testimonials"
import HowItWorks from "sections/05-HowItWorks"
import ShoppingCompanion from "sections/06-ShoppingCompanion"
import Call from "sections/08-CTA"
import { css, styled } from "styled-components"
import { desktopBreakpoint, tabletBreakpoint } from "styles/media"

export const centerCss = css`
	${fresponsive(css`
		width: ${desktopBreakpoint}px;
		margin: 0 auto;
	`)}

	${ftablet(css`
		width: ${tabletBreakpoint}px;
	`)}

	${fmobile(css`
		width: 375px;
	`)}
`

export function Head({ location }: HeadProps) {
	return (
		<Seo
			title="Response"
			description="Warehouse purchasing in one place"
			gatsbyPathname={location.pathname}
		/>
	)
}

export default function IndexPage() {
	return (
		<Wrapper>
			<Hero />
			<SocialProof />
			<Suspense>
				<YouVeePees />
			</Suspense>
			<Suspense>
				<HowItWorks />
			</Suspense>
			<Suspense>
				<Testimonials />
			</Suspense>
			<Suspense>
				<ShoppingCompanion />
			</Suspense>
			<Suspense>
				<Call />
			</Suspense>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	${centerCss};
`
